export default {
      id: "icon--winter-wonderland-usage",
      viewBox: "0 0 28 32",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--winter-wonderland-usage",
      toString: function () {
        return this.url;
      }
    }